import type { RouteObject } from 'react-router-dom';

/**
 * Diet area. OWNED BY `m8-diet` (M8); see docs/BUILD-ORCHESTRATION.md.
 *
 *   /diet               members with their diet and 7-day %, and the templates
 *   /diet/new           the builder: who is it for (?client=<id> | ?template=1)
 *   /diet/<planId>      the builder for a draft, a template, or a new version of a plan
 *
 * One `:planId` route serves `new` too, so saving a new plan can move the address to
 * /diet/<id> without remounting the builder. Pages load lazily.
 * The client profile's Diet tab renders `ClientDietPanel.tsx` (default export).
 */
export const dietRoutes: RouteObject[] = [
  {
    path: 'diet',
    handle: { crumb: 'Diet' },
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./DietPage')).DietPage }) },
      {
        path: ':planId',
        handle: { crumb: 'Builder' },
        lazy: async () => ({ Component: (await import('./DietBuilderPage')).DietBuilderPage }),
      },
    ],
  },
];
